function isNumberKey(text, event, decimalPlaces) {
  var returnValue = true;
  var charCode = event.which ? event.which : event.keyCode;
  var dotIndex = text.value.indexOf('.');
  var len = text.value.length;

  if (decimalPlaces > 0 && charCode == 46) {
    //Check if the text already contains the . character
    if (dotIndex === -1) {
      returnValue = true;
    } else {
      returnValue = false;
    }
  } else {
    if (charCode > 31 && (charCode < 48 || charCode > 57)) returnValue = false;
    else {
      if (dotIndex > 0) {
        var charAfterDot = len + 1 - dotIndex;
        if (charAfterDot > decimalPlaces + 1) {
          returnValue = false;
        }
      }
    }
  }
  return returnValue;
}

function isDateKey(text, event, allowSlashes, allowDashes) {
  var returnValue = true;
  var charCode = event.which ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) returnValue = false;
  if (allowSlashes && charCode === 47) returnValue = true;
  if (allowDashes && charCode === 45) returnValue = true;
  return returnValue;
}
